import React from 'react'
import PropTypes from 'prop-types'
import { observer } from 'mobx-react'
import classnames from 'classnames'
import styles from './styles.module.scss'
import Mq from '@/store/mq'

import { NavLink } from 'react-router-dom'
import ReadMore from '@/components/ReadMore'

function NoImagePlaceholder() {
	return (
		<div className={styles.noImagePlaceholder}>
			<div className={styles.inner}>
				<svg width="146px" height="146px" viewBox="0 0 146 146">
					<defs></defs>
					<g id="Symbols" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
						<g id="article-horizonal-b" transform="translate(-36.000000, -29.000000)">
							<g id="1-copy-4">
								<g id="Group">
									<g id="Icon" transform="translate(36.000000, 29.000000)">
										<circle
											id="Oval"
											fill="#F4F4F4"
											fillRule="nonzero"
											cx="73"
											cy="73"
											r="73"
										></circle>
										<path
											d="M68.3808559,69.6114812 C68.9871213,69.6114812 69.4815956,70.1040756 69.4815956,70.708036 C69.4815956,71.316284 68.9871213,71.8045908 68.3808559,71.8045908 L51.5219267,71.8045908 C50.9156613,71.8045908 50.421187,71.316284 50.421187,70.708036 C50.421187,70.1040756 50.9156613,69.6114812 51.5219267,69.6114812 L68.3808559,69.6114812 Z M68.3808559,80.4015803 C68.9871213,80.4015803 69.4815956,80.8898871 69.4815956,81.4981351 C69.4815956,82.1020955 68.9871213,82.5946899 68.3808559,82.5946899 L51.5219267,82.5946899 C50.9156613,82.5946899 50.421187,82.1020955 50.421187,81.4981351 C50.421187,80.8898871 50.9156613,80.4015803 51.5219267,80.4015803 L68.3808559,80.4015803 Z M68.3808559,91.1872931 C68.9871213,91.1872931 69.4815956,91.6755999 69.4815956,92.2838479 C69.4815956,92.8878083 68.9871213,93.3804027 68.3808559,93.3804027 L51.5219267,93.3804027 C50.9156613,93.3804027 50.421187,92.8878083 50.421187,92.2838479 C50.421187,91.6755999 50.9156613,91.1872931 51.5219267,91.1872931 L68.3808559,91.1872931 Z M92.0676735,69.6114812 C92.6782428,69.6114812 93.1684132,70.1040756 93.1684132,70.708036 C93.1684132,71.316284 92.6782428,71.8045908 92.0676735,71.8045908 L75.2131472,71.8045908 C74.6025779,71.8045908 74.1124075,71.316284 74.1124075,70.708036 C74.1124075,70.1040756 74.6025779,69.6114812 75.2131472,69.6114812 L92.0676735,69.6114812 Z M92.0676735,80.4015803 C92.6782428,80.4015803 93.1684132,80.8898871 93.1684132,81.4981351 C93.1684132,82.1020955 92.6782428,82.5946899 92.0676735,82.5946899 L75.2131472,82.5946899 C74.6025779,82.5946899 74.1124075,82.1020955 74.1124075,81.4981351 C74.1124075,80.8898871 74.6025779,80.4015803 75.2131472,80.4015803 L92.0676735,80.4015803 Z M92.0676735,91.1872931 C92.6782428,91.1872931 93.1684132,91.6755999 93.1684132,92.2838479 C93.1684132,92.8878083 92.6782428,93.3804027 92.0676735,93.3804027 L75.2131472,93.3804027 C74.6025779,93.3804027 74.1124075,92.8878083 74.1124075,92.2838479 C74.1124075,91.6755999 74.6025779,91.1872931 75.2131472,91.1872931 L92.0676735,91.1872931 Z"
											id="Combined-Shape"
											fill="#DF9218"
										></path>
									</g>
								</g>
							</g>
						</g>
					</g>
				</svg>
			</div>
		</div>
	)
}

@observer
class ArticleCard extends React.Component {
	static defaultProps = {
		thumbUrl: null,
		label: null,
		excerpt: null,
		horz: false,
		readmore: true
	}

	static propTypes = {
		thumbUrl: PropTypes.string,
		title: PropTypes.string.isRequired,
		dateStamp: PropTypes.string,
		label: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
		source: PropTypes.string,
		excerpt: PropTypes.string,
		horz: PropTypes.bool,
		to: PropTypes.string.isRequired,
		readmore: PropTypes.bool
	}

	render() {
		const { title, dateStamp, source, thumbUrl, label, excerpt, to } = this.props

		const articleClassnames = classnames(styles.article, {
			[styles.horizontal]: this.props.horz && !Mq.mobile
		})

		const headlineClassnames = classnames(styles.headline, {
			[styles.large]: Mq.desktop
		})

		const href = to.startsWith('http') ? to : undefined

		const Tag = href ? 'a' : NavLink

		return (
			<Tag to={to} href={href} target={href ? '_blank' : undefined}>
				<article className={articleClassnames}>
					<div className={styles.image}>
						{thumbUrl ? <img src={thumbUrl} alt="" /> : <NoImagePlaceholder />}
						{label && <span>{label}</span>}
					</div>
					<header className={styles.header}>
						<h2 className={headlineClassnames}>{title}</h2>
						<div className={styles.meta}>
							{source && <div className={styles.source}>{source}</div>}
							<div className={styles.dateStamp}>{dateStamp}</div>
						</div>
						{!Mq.mobile && excerpt && (
							<div className={styles.excerpt} dangerouslySetInnerHTML={{ __html: excerpt }} />
						)}
						{this.props.readmore && (
							<div className={styles.readmore}>
								<ReadMore />
							</div>
						)}
					</header>
				</article>
			</Tag>
		)
	}
}

export default ArticleCard
